import styled from 'styled-components';

export const Boxes = styled.div`
  
`;